import { Injectable } from '@angular/core';

import { DeleteCommandService } from 'pbc.angular';

import { IDeleteProjektStatusRequest, IDeleteProjektStatusResponse } from 'fa-kt.types';

@Injectable({
  providedIn: 'root',
})
export class DeleteProjektStatusCommandService extends DeleteCommandService<IDeleteProjektStatusRequest, IDeleteProjektStatusResponse> {
  readonly route = 'projekte/settings/projekt-status';
}
